import { useState, useEffect } from "react";

const useSliderDots = (sliderRef, videosLength, maxDots = 2) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const slider = sliderRef.current?.slider;
    if (!slider) return;

    const updateCurrentIndex = (info) => {
      const { index, items, slideCount } = info;
      const isAtEnd = index + items >= slideCount;
      setCurrentIndex(isAtEnd ? 1 : 0);
    };

    slider.events.on("indexChanged", updateCurrentIndex);

    return () => {
      slider.events.off("indexChanged", updateCurrentIndex);
    };
  }, [sliderRef]);

  let totalSlides = videosLength;
  let startDot = 0;

  if (totalSlides > maxDots) {
    if (currentIndex <= 0) startDot = 0;
    else if (currentIndex >= totalSlides - 1) startDot = totalSlides - maxDots;
    else startDot = currentIndex - 1;
  }

  const visibleDots = Array.from(
    { length: Math.min(maxDots, totalSlides) },
    (_, i) => startDot + i
  );

  const goToSlide = (index) => {
    if (sliderRef.current && sliderRef.current.slider) {
      sliderRef.current.slider.goTo(index);
    }
  };

  return { currentIndex, visibleDots, goToSlide };
};

export default useSliderDots;
